// extracted by mini-css-extract-plugin
export default {"social":"Social_social__vaGAA","social-layout2":"Social_social-layout2__TP+bJ"};